














import Proxyable from '@/mixins/proxyable';
import { IRequisition } from '@/models';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'RequisitionBuyerPicker',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      loading: false,
      errorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      buyers: 'requisition/getRequisitionBuyers'
    }),

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchRequisitionBuyers: 'requisition/fetchRequisitionBuyers'
    }),

    init() {
      this.loading = true;

      this.fetchRequisitionBuyers(this.requisition.id)
        .catch(() => {
          this.errorMessage = 'Error getting buyers';
        })
        .finally(() => (this.loading = false));
    }
  }
});
